var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataCircle"},[_c('div',{style:({height:_vm.calcHeight+'px',width:_vm.calcWidth}),attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }